module.exports = __webpack_public_path__ + "non-profit.1fGJIOBG.svg";